{
  "selectAsField": "Selecionar \"{value}\" como {fieldName}",
  "typeToSearchField": "Digite para pesquisar por {fieldName}",
  "licenseFieldLabel": "Selecione a placa do veículo (ex.: 215BG2)",
  "licenseFieldName": "Placa do veículo",
  "licensePlaceholder": "Pesquisar por placa",
  "dotFieldLabel": "Selecione o número DOT",
  "dotFieldName": "Número DOT",
  "dotPlaceholder": "Pesquisar por número DOT"
}
